import React, {Component} from 'react';
import {connect} from 'react-redux';
import propTypes from 'prop-types';
import Checkbox from 'rc-checkbox';

class FieldsTree extends Component {
    constructor() {
        super();
        this.state = {};
    };

    componentWillMount() {
        const {fieldFilters} = this.props;

        this.expandSelected(fieldFilters);
    };

    expandSelected = (filters) => {
        const that = this;

        filters.forEach(function(filter) {
            if (filter.children && filter.children.length > 0) {
                filter.children.forEach(function(child) {
                    that.setState({[`${filter.id}`]: true});
                });
                that.expandSelected(filter.children);
            }
        });
    };

    expandFieldTree = (id, isExpansible) => {
        const {expandTree} = this.props;

        this.setState({[`${id}`]: !this.state[id]});
        expandTree(id, isExpansible);
    };

    getFieldTree = (filters) => {
        const {setFilter} = this.props;

        return filters.map((filter, index) =>
                  <li className={`field-tree__item ${((filter.children && filter.children.length > 0) || filter.expansible) ? 'with-trigger' : ''}`} key={index}>
                      <div className={`field-tree__item-data ${((filter.children && filter.children.length > 0) || filter.expansible) ? 'with-trigger' : ''}`}>
                          {((filter.children && filter.children.length > 0) || filter.expansible) && !this.state[`${filter.id}`] &&
                              <button type="button" className="field-tree__open" onClick={() => this.expandFieldTree(filter.id, filter.expansible)}>
                                  <span>+</span>
                              </button>}

                          {filter.children && filter.children.length > 0 && this.state[`${filter.id}`] &&
                              <button type="button" className="field-tree__hide" onClick={() => this.expandFieldTree(filter.id, filter.expansible)}>
                                  <span>-</span>
                              </button>}

                          {((filter.children && filter.children.length > 0) || filter.expansible) &&
                              <div className="field-tree__separator"></div>}

                          <label className={`field-tree__item-label ${!filter.count ? 'no-count' : ''}`}>
                              {!!filter.count &&
                                  <Checkbox
                                    prefixCls="checkbox--regular"
                                    value={filter.id}
                                    checked={filter.selected}
                                    onChange={() => setFilter('HEADINGS', filter.id)}/>}
                              {filter.label}
                              <span>({filter.count})</span>
                          </label>
                      </div>
                      {this.state[`${filter.id}`] && filter.children && filter.children.length > 0 &&
                          <ul className="field-tree__item-children">
                              {this.getFieldTree(filter.children)}
                          </ul>}
                  </li>)
    };

    render() {
        const {fieldFilters} = this.props;

        return (
            <ul className="field-tree">
                {this.getFieldTree(fieldFilters)}
            </ul>
        );
    };
};

FieldsTree.propTypes = {
    clang: propTypes.string.isRequired
};

const mapStateToProps = state => ({
    clang: state.language.currentLanguage
});

export default connect(mapStateToProps)(FieldsTree);



// WEBPACK FOOTER //
// ./src/components/fields-tree/FieldsTree.js